// @flow

import React, { PureComponent } from 'react';
import { I13nAnchor } from 'react-i13n';
import { DEFAULT_DRUID_RECORD_LIMIT, commas } from '../../../support/utils';

type Props = {
  limit?: number
};

class DataLimitWarning extends PureComponent<Props> {
  render() {
    const { limit = DEFAULT_DRUID_RECORD_LIMIT } = this.props;

    return (
      <span>
        {`We will load the top ${commas(
          limit
        )} records for each event or metric. Some low-volume records may be missing from the displayed analytics when looking at many different compare bys. In particular, data sorted by ascending values may be limited. To reduce the amount of data fetched, try adding additional filters or looking at a shorter time range. Alternatively, you can export your data using`}{' '}
        <I13nAnchor
          href="https://docs.branch.io/pages/exports/webhooks/"
          target="_blank"
          rel="noopener noreferrer"
          i13nModel={{
            action: 'click',
            label: 'Data limit reached - webhook link'
          }}
          data-testid="webhook-link"
        >
          webhooks
        </I13nAnchor>{' '}
        or our{' '}
        <I13nAnchor
          href="https://docs.branch.io/pages/exports/api-v3/"
          target="_blank"
          rel="noopener noreferrer"
          i13nModel={{
            action: 'click',
            label: 'Data limit reached - data export api link'
          }}
          data-testid="data-export-api-link"
        >
          Data Export API
        </I13nAnchor>
        {'.'}
      </span>
    );
  }
}

export default DataLimitWarning;
